import { render } from "./StudentCalendar.vue?vue&type=template&id=7a9fb06e&scoped=true"
import script from "./StudentCalendar.vue?vue&type=script&lang=js"
export * from "./StudentCalendar.vue?vue&type=script&lang=js"

import "./StudentCalendar.vue?vue&type=style&index=0&id=7a9fb06e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9fb06e"]])

export default __exports__